import { memo } from 'react';

import { MegaphoneIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { Button } from '@/components/ui/button';
import { useSidebar } from '@/hooks/useSidebar';

export const Changelog = memo(() => {
  const { t } = useTranslation();
  const { isOpen, close } = useSidebar();

  // Beamer's product-updates panel opens on top of our right-side sidebar,
  // which produces two stacked drawers with two close buttons. Dismiss ours
  // so the user only sees Beamer's panel — but only if one is actually open,
  // because `close` dispatches setSidebarContent(null), and the sidebar
  // middleware persists that as user-dismiss intent.
  const handleClick = () => {
    if (isOpen()) {
      close();
    }
  };

  return (
    <InfoTooltip content={t('main_navigation.whats_new')} delayDuration={200}>
      <span>
        <Button
          id="changelog-button"
          aria-label={t('main_navigation.changelog')}
          className="beamer h-8 w-8 rounded hover:bg-white/16 [&_svg]:size-5 [&_svg]:p-0 [&_svg]:text-navigation-element"
          variant="ghost-neutral"
          size="icon-md"
          onClick={handleClick}
        >
          <MegaphoneIcon size={20} />
        </Button>
      </span>
    </InfoTooltip>
  );
});

Changelog.displayName = 'Changelog';
